<template>
  <div class="MdHome">
        <!-- 轮播图 -->
    <el-carousel class="titleSwiper"  loop>
      <el-carousel-item v-for="item in banner" :key="item.id">
        <div class="mdCarouselBox">
            <div class="mdCarouselBoxTitle">
                <p class="mdCarouselBoxTitleHead">{{item.title}}</p>
                <p class="mdCarouselBoxTitleText">{{item.info}}</p>
                <div class="mdCarouselBoxTitleA" href="javascript:;" @click="goAbout">了解更多</div>
            </div>
            <img class="mdCarouselBoxImg" :src="item.img" alt="">
        </div>
      </el-carousel-item>
    </el-carousel>
    <!-- 2层数据 -->
        <!-- 使命 -->
    <div class="mission">
        <img src="./index/pic1.png" alt="">
    </div>
     <!-- 使命 -->
    <!-- 数字转型数据 -->
    <div class="mission">
        <img src="./index/pic2.png" alt="">
    </div>
    <!-- 数字转型数据 -->
    <!-- 产品线 -->
    <!-- <div class="product">
      <p class="productTitle">时空产品</p>
      <div class="productTop">
        <p v-for="item in titleProduct" :key="item.ID" :class="indexFourList == item.ID?'pTextMd':''"  @click="onIndexFourList(item)">{{item.Name}}</p>
      </div>
      <div class="productBottom">
        <ProductSwiper :products-list="titleProductList"/>
      </div>
    </div> -->
    <!-- 产品线 -->
    <!-- 数字转型数据 -->
    <!-- <div class="detailNum">
      <div class="detailNumTop">
        <p class="detailNumTopBig">持续推动医药大健康产业数字经济转型</p>
        <p class="detailNumTopLittle">为客户提供更全面的数智化解决方案</p>
      </div>
      <div class="detailNumBottom">
        <div class="threeBottomItem" v-for="(item, index) in threeList" :key="index">
            <div class="threeBottomItemT">
                <p class="threeBottomItemTL">
                   <span >{{item.number}}</span>
                  <i>+</i>
                </p>
                <p class="threeBottomItemTR">{{item.unit}}</p>
            </div>
            <p class="threeBottomItemB">{{item.text}}</p>
        </div>
      </div>
    </div> -->
    <!-- 数字转型数据结束 -->
    <!-- 新闻中心 -->
    <div class="mdNews">
      <p class="title">新闻中心</p>
      <div class="newsTop"  @click="goNewsItem(headNews)">
        <div class="newsTopImg">
          <!-- <img src="./index/pcHome/five.png" alt=""> -->
          <el-image :src='headNews.TitlePic' class="fiveBoxBottomLImg">
            <div slot="error" class="image-slot">
              <img class="fiveBoxBottomLImg" src="./index/pcHome/five.png" alt="">
            </div>
          </el-image>
        </div>
        <p class="newsTopTime">{{headNews.AddTime|timeFormat}}</p>
        <p class="newsTopTitle">{{headNews.Title}}</p>
      </div>
      <div class="newsList">
        <div class="newsItem" v-for="item in headNewsL" :key="item.ID" @click="goNewsItem(item)">
          <p class="newsItemTime">{{item.AddTime|timeFormat}}</p>
          <p class="newsItemTitle">{{item.Title}}</p>
        </div>
      </div>
      <div class="newsMore" @click="goNews">更多新闻 ></div>
    </div>
    <!-- 新闻中心 -->
    <!-- 合作伙伴 -->
    <div class="partner">
      <p class="title">合作伙伴</p>
      <div class="partnerList">
        <MateMore class="partnerItem"/><MateMoreTwo class="partnerItem"/><MateMore class="partnerItem"/>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <!-- 联系我们 -->
    <div class="contact" @click="goContactUs">
      <img src="./home/contact.png" alt="">
    </div>
    <!-- 联系我们 -->
  </div>
</template>

<script>
// 首页新闻
import { getArticleApiHome } from '@/api/news'
// 引入时间格式过滤
import { timeFormat } from '@/utils/myFilters'
// 引入根路径
import request from '@/utils/request'
import MateMore from './components/mdSwiper/mateMore.vue'
import MateMoreTwo from './components/mdSwiper/mateMoreTwo.vue'
import ProductSwiper from './components/mdSwiper/productSwiper.vue'
// import ProductSwiper from './components/mdSwiper/newSwiper.vue'
export default {
  components: { MateMore, MateMoreTwo, ProductSwiper },
  data () {
    return {
      // 1层
      banner: [
        { id: 1, title: '企业数智化整体解决方案服务商', info: '郑州时空成立于2002年，公司20多年来一直专注于以数字化、智能化推动企业进步，是国内领先的企业数智化整体解决方案服务商。', img: require('./index/pcHome/title.png') },
        { id: 2, title: '智能仓储物流设备集成', info: '智能仓储物流设备集成、工业智能化设备等方面持续投入，为客户提供更全面的数智化解决方案，不断超越自我，追求卓越', img: require('./index/pcHome/title2.png') }
      ],
      threeList: [
        { number: 25, unit: '年', text: '行业经验' },
        { number: 55, unit: '家', text: '全国核心成员公司' },
        { number: 1000, unit: '人', text: '专业团队' },
        { number: 2.4, unit: '亿', text: '体系合并年产值' },
        { number: 6000, unit: '家', text: '医药公司客户' },
        { number: 8000, unit: '家', text: '零售药店' },
        { number: 300000, unit: '个', text: 'PC、移动端' },
        { number: 10, unit: '年', text: '市场占有率领先' }
      ],
      titleProductList: [], // 产品线子级
      indexFourList: 1, // 左侧标题index
      pressCenter: [], // 首页新闻
      headNews: [], // 头部新闻
      headNewsL: [] // 头部新闻列表

    }
  },
  watch: {
    titleProduct: {
      handler (v, o) {
        this.titleProductList = v[0].ProductsList
        this.indexFourList = v[0].ID
        // 将组件等分
        // const newList = []
        // for (var i = 0; i < this.titleProductList.length; i += 3) {
        //   newList.push(this.titleProductList.slice(i, i + 3))
        // }
        // this.titleProductList = newList
        // console.log(this.titleProductList)
      },
      deep: true
    }
  },
  filters: {
    timeFormat
  },
  computed: {
    // 产品线
    titleProduct () {
      return this.$store.state.productTitle
    }
  },
  mounted () {
    this.getArticleApiHome()
  },
  methods: {
    goAbout () {
      this.$router.push('/aboutUs')
      this.activeIndex = '/aboutUs'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    goContactUs () {
      this.$router.push('/contactUs')
      this.activeIndex = '/contactUs'
      this.$store.commit('getActiveIndex', this.activeIndex)
      localStorage.setItem('index', this.activeIndex)
    },
    // 产品线
    onIndexFourList (item) {
      this.indexFourList = item.ID
      this.titleProductList = item.ProductsList
      // 将组件等分
      // const newList = []
      // for (var i = 0; i < this.titleProductList.length; i += 3) {
      //   newList.push(this.titleProductList.slice(i, i + 3))
      // }
      // this.titleProductList = newList
      // console.log(this.titleProductList)
    },
    // 获取首页新闻
    async getArticleApiHome () {
      const res = await getArticleApiHome()
      // console.log(res, '首页新闻')
      if (res.Msg === '获取成功') {
        this.pressCenter = res.Data
        this.pressCenter.forEach(item => {
          item.TitlePic = request.defaults.baseURL + item.TitlePic
        })
        // console.log(this.pressCenter)
        if (this.pressCenter.length > 0) {
          this.headNews = this.pressCenter.shift()
          this.headNewsL = this.pressCenter.splice(0, 4)
          // console.log(this.headNewsL, 'this.headNewsL')
          // this.headNewsShow = false
        } else {
          // this.headNewsShow = true
        }
      }
    },
    goNewsItem (item) {
      // this.$router.push(newsItem)
      this.$router.push({ path: `/newsItemNew/${item.ID}` })
    },
    goNews () {
      this.$router.push({ path: '/newsCenter' })
    }
  }

}
</script>

<style lang="scss" scoped>
$md:72/192*2;
.MdHome{
}
// 1层
.titleSwiper{
    width: 100%;
    height: 1000px/$md;
}
 ::v-deep .el-carousel__container{
  width: 100%;
  height: 1000px/$md;
}
.el-carousel{
  width: 100%;
    height: 1000px/$md;
}

.el-carousel__item{
  width: 100%;
  height: 1000px/$md;
}
// 轮播图item
.mdCarouselBox{
      width: 100%;
      height: 1000px/$md;
      background: #000;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
}
// 轮播图图片
.mdCarouselBoxImg{
    width: 100%;
    height: 1000px/$md;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 970;
}
// 轮播图中间文字
.mdCarouselBoxTitle{
    width: 630px/$md;
    height: 449px/$md;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 980;
    .mdCarouselBoxTitleHead{
        width: 340px/$md;
        font-size: 46px/$md;
        margin: 0;
    }
    .mdCarouselBoxTitleText{
        font-size: 32px/$md;
        line-height: 50px/$md;
        letter-spacing: 2px/$md;
    }
    .mdCarouselBoxTitleA{
        width: 168px/$md;
        height: 56px/$md;
        background: #2380E1;
        color: #FFFFFF;
        font-size: 20px/$md;
        border-radius: 6px/$md;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        line-height: 56px/$md;
    }
}
// 2层
.mission{
  width: 100%;
  height: 427px/$md;
  img{
    width: 100%;
    height: 100%;
  }
}
// 产品线
.product{
  width: 100%;
  height: 850px/$md;
  overflow: hidden;
  background: #F2F4F8;
  .productTitle{
    height: 67px/$md;
    font-size: 48px/$md;
    font-weight: 500;
    line-height: 67px/$md;
    color: #252B3A;
    text-align: center;
    margin-bottom: 60px/$md;
    margin-top: 50px/$md;
  }
  .productTop{
    width: 100%;
    height: 60px/$md;
    border-bottom: 2px/$md solid #DCDCDC;
    // display: flex;
    // align-items: center;
    // justify-content: space-around;
    overflow:hidden;
  white-space:nowrap;
  display: -webkit-box;
  overflow-x: scroll;
  overflow-y: hidden;
    p{
      font-size: 28px/$md;
      font-weight: 500;
      line-height: 24px/$md;
      margin: 0 20px/$md;
      color: #333333;
      height: 100%;
    display:inline-block;
    }
    // 选中样式
    .pTextMd{
      border-bottom: 5px/$md solid #2380E1;
      color: #2380E1;
    }
  }
  // 隐藏滚动条
             .productTop::-webkit-scrollbar {
              display: none;
            }
  .productBottom{
    width: 100%;
    height: 620px/$md;
    overflow: hidden;
    display: flex;
    justify-content: center;
  }
}
// 产品线
 // 数字转型数据
  // .detailNum{
  //   width: 750px/$md;
  //   height: 442px/$md;
  //   background: url('./home/detailNum.png') no-repeat ;
  //   background-size:100% 100%;
  //   color: #fff;
  //   overflow: hidden;
  //   .detailNumTop{
  //     height: 100px/$md;
  //     display: flex;
  //     flex-direction: column;
  //     align-items: center;
  //     justify-content: space-between;
  //     margin-top: 50px/$md;
  //     .detailNumTopBig{
  //       font-size: 32px/$md;
  //     }
  //     .detailNumTopLittle{
  //       font-size: 24px/$md;
  //     }
  //     p{
  //       margin: 0;
  //     }
  //   }
  //   .detailNumBottom{
  //     width: 700px/$md;
  //     height: 166px/$md;
  //     display: flex;
  //     flex-wrap: wrap;
  //     justify-content: space-between;
  //     font-size: 14px/$md;
  //     margin: auto;
  //     margin-top: 56px/$md;
  //     .threeBottomItem{
  //        width: 150px/$md;
  //        margin-bottom:44px/$md ;
  //        display: flex;
  //        flex-direction: column;
  //        justify-content: center;
  //        .threeBottomItemT{
  //         display: flex;
  //         justify-content: center;
  //         .threeBottomItemTL{
  //            position: relative;
  //             margin-right: 11px/$md;
  //            i{
  //             position: absolute;
  //             top: -10px/$md;
  //            }
  //         }
  //        }
  //        .threeBottomItemB{
  //         text-align: center;
  //         font-size: 14px/$md;
  //        }
  //     }
  //   }
  // }
  // 数字转型数据结束
  // 新闻中心
  .mdNews{
    width: 690px/$md;
    margin: auto;
    .title{
      width: 100%;
      height: 67px/$md;
      text-align: center;
      font-size: 48px/$md;
      margin-top: 50px/$md;
      margin-bottom: 50px/$md;
    }
    // 新闻头部
    .newsTop{
      width: 690px/$md;
      height: 645px/$md;
      margin: auto;
      border-bottom: 1px/$md solid  #DCDCDC;
      overflow: hidden;
      .newsTopImg{
        width: 100%;
        height: 390px/$md;
        .fiveBoxBottomLImg{
          width: 100%;
          height: 100%;
        }
      }
      .newsTopTime{
        height: 42px/$md;
      margin-top: 40px/$md;
      margin-bottom: 30px/$md;
      font-size: 30px/$md;
      color: #585D6C;
      }
      .newsTopTitle{
        width: 642px/$md;
        height: 98px/$md;
        font-size: 34px/$md;
        font-weight: 500/$md;
        line-height: 50px/$md;
        color: #000000;
      }
    }
    // 新闻列表
    .newsList{
      width: 690px/$md;
      margin: auto;
      .newsItem{
        width: 100%;
        height: 208px/$md;
        border-bottom: 2px/$md solid  #DCDCDC;;
        .newsItemTime{
          height: 42px/$md;
          font-size: 30px/$md;
          font-weight: 500/$md;
          line-height: 50px/$md;
          color: #585D6C;
          margin-top: 24px/$md;
          margin-bottom: 20px/$md;
        }
        .newsItemTitle{
          width: 585px/$md;
          height: 88px/$md;
          font-size: 28px/$md;
          font-weight: 500/$md;
          line-height: 48px/$md;
          color: #000000;
        }
      }
    }
    // 更多
    .newsMore{
      width: 216px/$md;
      height: 78px/$md;
      font-size: 30px/$md;
      background: #FFFFFF;
      border: 2px/$md solid #DCDCDC;
      border-radius: 10px/$md;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 40px/$md;
      margin-bottom: 70px/$md;
        }
  }
  // 新闻中心
  // 合作伙伴
.partner{
  width: 100%;
  height: 577px/$md;
  background: #F2F4F8;
  overflow: hidden;
  .title{
      margin-top: 60px/$md;
      margin-bottom: 50px/$md;
      height: 67px/$md;
      font-size: 48px/$md;
      font-weight: 500;
      line-height: 24px/$md;
      color: #252B3A;
      text-align: center;
  }
  .partnerList{
    width: 690px/$md;
    margin: auto;
    overflow: hidden;
    .partnerItem{
      margin-bottom: 30px/$md;
    }
  }
}
  // 合作伙伴
  // 联系我们
  .contact{
    width: 100%;
    height: 442px/$md;
    img{
      width: 100%;
      height: 100%;
    }
  }
  // 联系我们
  p{
    margin: 0;
  }
</style>
